import React from 'react';
import CodeBlock from '../components/CodeBlock';

const Integrations = () => {
  return (
    <div className="page">
      <div className="page-header">
        <h1>🔌 Intégrations</h1>
        <p>
          Connectez Whakup à vos outils existants sans une ligne de code grâce aux apps officielles n8n et Zapier.
        </p>
      </div>

      <div className="section">
        <h2>n8n</h2>
        <p>
          n8n est une plateforme open-source de workflow automation. Notre node communautaire
          permet d'envoyer des messages WhatsApp et de déclencher des workflows depuis vos
          événements Whakup.
        </p>

        <h4>Installation</h4>
        <CodeBlock language="bash" code={`npm install n8n-nodes-whakup`} />
        <p>
          Ou via l'UI n8n : <code>Settings → Community Nodes</code> → entrez <code>n8n-nodes-whakup</code>.
        </p>

        <h4>Nodes</h4>
        <table className="params-table">
          <thead><tr><th>Node</th><th>Description</th></tr></thead>
          <tbody>
            <tr><td><strong>Whakup</strong> (Action)</td><td>Envoyer template, gérer contacts, groupes, campagnes</td></tr>
            <tr><td><strong>Whakup Trigger</strong></td><td>Déclencher un workflow sur un événement Whakup (multi-events)</td></tr>
          </tbody>
        </table>

        <h4>Authentification</h4>
        <p>
          Créez vos credentials "Whakup API" dans n8n avec votre API Key + Workspace ID.
          Le node échange automatiquement votre API Key contre un JWT à chaque exécution.
        </p>

        <div className="alert alert-info">
          🔒 La signature HMAC SHA-256 des webhooks est vérifiée automatiquement par le Trigger node.
        </div>
      </div>

      <div className="section">
        <h2>Zapier</h2>
        <p>
          Notre app Zapier officielle permet de connecter Whakup à 6000+ apps tierces (HubSpot,
          Salesforce, Google Sheets, Slack, etc.) sans écrire de code.
        </p>

        <h4>Installation</h4>
        <p>Cherchez "Whakup" dans le store Zapier et cliquez "Connect".</p>

        <h4>Triggers disponibles</h4>
        <ul>
          <li><strong>New Incoming Message</strong> — un contact répond</li>
          <li><strong>New Contact</strong> — nouveau contact créé</li>
          <li><strong>Campaign Completed</strong> — fin d'une campagne</li>
        </ul>

        <h4>Actions disponibles</h4>
        <ul>
          <li><strong>Send WhatsApp Template</strong> — envoi d'un template à un destinataire</li>
          <li><strong>Create or Update Contact</strong> — création/mise à jour de contact</li>
        </ul>

        <h4>Authentification</h4>
        <p>
          Saisissez votre API Key + Workspace ID lors de la connexion. Zapier échange contre un JWT
          via une session auth (refresh automatique).
        </p>
      </div>

      <div className="section">
        <h2>Make (ex-Integromat)</h2>
        <p>
          Pas d'app Make officielle pour l'instant. Utilisez le module générique <strong>HTTP</strong> :
        </p>
        <ul>
          <li>Auth : POST <code>/api/public/auth</code> avec header <code>X-API-Key</code> → récupérer le JWT</li>
          <li>Action : POST <code>/api/v1/messages/send-template</code> avec <code>Authorization: Bearer JWT</code></li>
        </ul>
        <p>
          Ou utilisez le module <strong>Webhooks</strong> de Make pour recevoir les événements Whakup
          et chaîner avec d'autres scenarios.
        </p>
      </div>

      <div className="section">
        <h2>Custom (HTTP direct)</h2>
        <p>
          Vous pouvez consommer l'API Whakup directement depuis n'importe quel langage / outil qui supporte HTTP.
          Voir la <a href="/authentication">page Authentication</a> pour le flow complet, et la
          <a href="/examples"> page Examples</a> pour des snippets en cURL, Python, Node.js, PHP.
        </p>
      </div>
    </div>
  );
};

export default Integrations;
